export const FETCH_USER_ADDRESS_REQUEST = 'FETCH_USER_ADDRESS_REQUEST';
export const FETCH_USER_ADDRESS_SUCCESS = 'FETCH_USER_ADDRESS_SUCCESS';
export const FETCH_USER_ADDRESS_FAILURE = 'FETCH_USER_ADDRESS_FAILURE';
export const FETCH_USER_DISTANCE = 'FETCH_USER_DISTANCE';
export const SET_DEFAULT_ADDRESS = 'SET_DEFAULT_ADDRESS';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
